import axios from "axios";

export const featuredVideos = (channelName) => {
  return axios.get("/channel/get/" + channelName);
};
